export const isCallCenterUser = user => {
    if (user) {
        const callCenterRoleName = "CallCenter";
        if (Array.isArray(user.profile.role)) {
            if (user.profile.role.includes(callCenterRoleName)) {
                return true;
            }
        } else {
            return user.profile.role === callCenterRoleName;
        }
    } else {
        return false;
    }
};
